var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHealthVisit = function SvgHealthVisit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      boxShadow: "0 0 7px #ccc",
      borderRadius: 10,
      margin: 10
    },
    viewBox: "0 0 52 52"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "#fff",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M39.684 13.727h-3.597v-.461C36.087 10.37 33.765 8 30.888 8h-9.81c-2.876 0-5.198 2.37-5.198 5.266v.46h-3.597C9.93 13.727 8 15.669 8 18.039v17.805c0 2.567 2.06 4.673 4.643 4.673h26.714c2.55 0 4.643-2.073 4.643-4.673V18.038c-.033-2.37-1.962-4.311-4.316-4.311m-7.324 0H19.608v-.461a1.47 1.47 0 0 1 1.471-1.481h9.81a1.47 1.47 0 0 1 1.47 1.48zm-15.172-.461c0-2.172 1.765-3.95 3.89-3.95h9.81c2.158 0 3.89 1.778 3.89 3.95v.46h-1.11v-.46a2.786 2.786 0 0 0-2.78-2.798h-9.81a2.786 2.786 0 0 0-2.779 2.798v.46h-1.111zm25.144 22.577c0 1.646-1.341 3.028-3.008 3.028H12.642c-1.635 0-3.008-1.35-3.008-3.028V18.04a2.646 2.646 0 0 1 2.648-2.666h27.4a2.646 2.646 0 0 1 2.649 2.666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    stroke: "#1F4970",
    strokeWidth: 0.5,
    d: "M32.752 24.39h-4.088v-4.246a.66.66 0 0 0-.654-.658h-4.055a.66.66 0 0 0-.653.658v4.246h-4.088a.66.66 0 0 0-.653.658v4.147c0 .362.294.658.653.658h4.12V34.1c0 .362.294.658.654.658h4.022c.36 0 .654-.296.654-.658v-4.246h4.087c.36 0 .654-.296.654-.658v-4.147a.66.66 0 0 0-.654-.658Zm-.655 4.147H28.01a.66.66 0 0 0-.653.658v4.246h-2.715v-4.246a.66.66 0 0 0-.654-.658h-4.12v-2.83h4.12c.36 0 .654-.296.654-.658v-4.246h2.714v4.245c0 .362.294.659.654.659h4.087z"
  })));
};
export default SvgHealthVisit;